import React from 'react'
import AnchorLink from './anchor-link'

const Toc = ({items}) => {
    return (
    <div class="p-nav-contents">
        <nav>
            <span class="c-nav-contents-title">目次</span>
            <HeaderList items={items} />
        </nav>
    </div>
    )
}

const HeaderList = ({items, pIndex=null}) => {
    if (!items) return false
    return (
        <ul>
            {items.map(( item, index ) => {
                const pagelink = (() => {
                    const url = item.url + ''
                    if (url.length === 0) return ''
                    return encodeURIComponent(url.replace(/^#/, ''))
                })()
                const no = pIndex !== null ? `${pIndex + 1}-${index+1}` : `${index+1}`
                return (
                <li key={`toc-${no}`}>
                    <AnchorLink to={`#${pagelink}`}>{no}. {item.title}</AnchorLink>
                    <HeaderList items={item.items} pIndex={index} />
                </li>
                )}
            )}
        </ul>
    )
}



export default Toc;